var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{key:_vm.$route.path,attrs:{"to":"crumbs"}},[_c('span',[_vm._v("My Benefits")])]),_vm._v(" "),_c('nuxt-child')],1)}
var staticRenderFns = []

export { render, staticRenderFns }